import { render, staticRenderFns } from "./KSContents.vue?vue&type=template&id=48009563&scoped=true&lang=pug&"
import script from "./KSContents.vue?vue&type=script&lang=ts&"
export * from "./KSContents.vue?vue&type=script&lang=ts&"
import style0 from "./KSContents.vue?vue&type=style&index=0&id=48009563&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48009563",
  null
  
)

export default component.exports